import React, { useEffect } from 'react';
import { useNavigate, useParams, useLocation } from "react-router-dom";
//import { toast } from "sonner";

import MainLayout from "@/layouts/MainLayout.tsx";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Loader2 } from "lucide-react";

// interface LocationState {
//   accessVerified?: boolean;
//   patientName?: string;
//   expiresAt?: string;
//   patientId?: string;
//   accessCode?: string;
// }

const QuestionnaireInfo: React.FC = () => {
  const { patientId, encounterId } = useParams<{ patientId: string; encounterId: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(true);
  //const [accessCode, setAccessCode] = React.useState<string | null>(null);

  useEffect(() => {
    // Check if we have the required access information
    navigate({
      pathname: `/patients/${patientId}/${encounterId}/questionnaire/phq-9`,
    });
    setIsLoading(false);
  }, [location, navigate]);

  // const handleStartQuestionnaire = () => {
  //   if (!accessCode || !patientId) return;
  //   navigate({
  //     pathname: `/patients/${patientId}/questionnaire/phq-9`,
  //   });
    
  // };

  if (isLoading) {
    return (
      <MainLayout>
        <div className="flex items-center justify-center min-h-[60vh]">
          <Loader2 className="h-8 w-8 animate-spin text-green-500" />
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="flex items-center justify-center min-h-[60vh] px-4">
        <Card className="max-w-xl w-full p-6 space-y-4 rounded-2xl shadow-[8px_0_24px_-4px_rgba(74,222,128,0.3)] border border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800">PHQ-9 Questionnaire</h2>
          <p className="text-sm text-gray-600">
            The PHQ-9 is a clinically validated tool used to screen for the presence and severity of depression. 
            It consists of 9 short questions and helps providers understand your mental health better.
          </p>
          <p className="text-sm text-gray-600">
            Your responses are confidential and help us ensure you get the care you need.
          </p>
          <Button
            className="w-full mt-4 h-[56px] text-white font-semibold text-base rounded-full bg-gradient-to-r from-green-400 to-green-500 hover:scale-[1.02] transition-transform shadow-lg shadow-green-300/40"
            //onClick={handleStartQuestionnaire}
            //disabled={!accessCode}
          >
            Start Questionnaire
          </Button>
        </Card>
      </div>
    </MainLayout>
  );
};

export default QuestionnaireInfo;
